import { PlusOutlined } from "@ant-design/icons";
import { unwrapResult } from "@reduxjs/toolkit";
import { Button, Col, Space, Image, notification } from "antd";
import { RcFile } from "antd/lib/upload";
import { UploadFile } from "antd/lib/upload/interface";
import React, { ReactElement, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { RootDispatch } from "../../app/store";
import FileUpload from "../../compnents/file/FileUpload";
import { PrintOutlined } from "../../compnents/icons/Icons";
import { EditableList } from "../../compnents/list/EditableList";
import { NavBar } from "../../compnents/nav/NavBar";
import { StateSwitch } from "../../compnents/widgets/StateSwitch";
import { PrintTemplate } from "../../models/print";
import { GetPrintTemplateListParams } from "../../services/print";
import { ThemeContext } from "../../theme/ThemeContext";
import {
  assginPrintTemplate,
  getPrintTemplateList,
  removePrintTemplate,
  selectPrintTemplatePage,
  deleteTemplate,
  getImgUrl,
  getUploadImg
} from "./printSlice";

export const PrintAssignment = (): ReactElement => {
  // const dispatch = useDispatch<RootDispatch>();
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext);

  const { tenantId } = useParams<{ tenantId?: string }>();

  const page = useSelector(selectPrintTemplatePage);

  const [params, setParams] = useState<GetPrintTemplateListParams>({
    current: 1,
    tenantId,
  });

  const [imgSrc, setImgSrc] = useState('')   //预览图片路径

  const [visible, setVisible] = useState(false)

  const [fileList, setFileList] = useState<UploadFile[]>([])

  const [btnLoading, setBtnLoading] = useState('')

  const [viewBtn, setViewBtn] = useState('')

  const [deleteBtn, setDeleteBtn] = useState('')

  useEffect(() => {
    dispatch(getPrintTemplateList(params));
  }, [params]);

  const deleteImg = (id: string) => {   //删除
    dispatch(deleteTemplate({ id })).then(unwrapResult).then(() => {
      notification.success({ message: '删除成功' })
      dispatch(getPrintTemplateList(params));
    }).finally(() => setDeleteBtn(''))
  }
  const getImg = (id: string) => {   //获取预览路径
    dispatch(getImgUrl({ id })).then(unwrapResult).then((res) => {
      if (res.templatePreview != '') {
        setImgSrc(res.templatePreview)
        setVisible(true)
      } else {
        notification.error({ message: '请先上传预览图' })
      }

    }).finally(() => setViewBtn(''))
  }


  return (
    <Col
      style={{
        height: "calc(100% - 20px)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >


      <Col
        style={{
          flex: 1,
          marginTop: 10,
          padding: 15,
          backgroundColor: theme.pn,
          borderRadius: theme.br,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <EditableList<PrintTemplate>
          style={{ flex: 1, overflow: "auto" }}
          page={page}
          columns={[
            {
              title: "序号",
              key: "no",
              align: "center",
              width: "3rem",
              render: (_1, _2, i) =>
                `${page.size * (page.current - 1) + i + 1}`,
            },
            {
              title: "模版描述",
              dataIndex: "templateDesc",
              align: "center",
            },
            {
              title: "分配状态",
              key: "state",
              align: "center",
              width: "10rem",
              render: function ShowState(_, t) {
                return (
                  <StateSwitch
                    value={t.assigned}
                    onLabel="已分配"
                    offLabel="未分配"
                    onChange={(value) => {
                      let promise: Promise<any>;
                      if (value) {
                        promise = dispatch(
                          assginPrintTemplate({
                            ...t,
                            templateId: t.id,
                            tenantId,
                            id: "",
                          })
                        );
                      } else {
                        promise = dispatch(removePrintTemplate(t.templateId));
                      }
                      promise
                        .then(unwrapResult)
                        .then(() => {
                          dispatch(getPrintTemplateList(params));
                        })
                        .catch(() => {
                          // do nothing.
                        });
                    }}
                  />
                );
              },
            },
            {
              title: "操作",
              dataIndex: "templateDesc",
              align: "center",
              width: "10rem",
              render: function Element(_, r) {
                return <>
                  <Space>
                    <Button type="primary" loading={r.id == viewBtn} size="small" onClick={() => {

                      getImg(r.id)
                      setViewBtn(r.id)

                    }}>预览</Button>
                    <Button type="primary" loading={r.id == deleteBtn} size="small" onClick={() => {
                      deleteImg(r.id)
                      setDeleteBtn(r.id)
                    }}>删除预览图</Button>


                    <FileUpload
                      count={fileList.length || 0}
                      maxCount={100}
                      files={fileList}
                      disabled={r.id == btnLoading}
                      btn={(bol) => setBtnLoading('')}
                      beforeUpload={(file) => {
                        setBtnLoading(r.id)
                        if (file.type.includes('png') ||
                          file.type.includes('tiff') ||
                          file.type.includes('jpg') ||
                          file.type.includes('jpeg') ||
                          file.type.includes('bmp') ||
                          file.type.includes('heic') ||
                          file.type.includes('webp')
                        ) {
                          if ((file.size / 1024 / 1024) < 1) {
                            return true
                          } else {
                            notification.info({ message: '图片大于1M,请重新选择!' })
                            setBtnLoading('')
                            return false
                          }
                        }
                        notification.info({ message: '请上传图片' })
                        setBtnLoading('')
                        return false
                      }}
                      onUpload={(file, i) => {

                        setFileList([
                          ...fileList,
                          {
                            uid: file.uid,
                            size: file.size,
                            name: file.name,
                            type: file.type,
                            originFileObj: {} as RcFile,
                            url: i,
                          },
                        ])

                        dispatch(getUploadImg({ file, id: r.id }))   //获取图片路径
                          .then(unwrapResult)
                          .then(() => {
                            notification.success({ message: '上传成功' })
                            dispatch(getPrintTemplateList(params));
                          })
                          .finally(() => setBtnLoading(''))
                      }}
                    >
                      <Button loading={r.id == btnLoading} icon={<PlusOutlined />}>上传附件</Button>

                    </FileUpload>
                  </Space>
                </>
              }
            },
          ]}
          onChangePage={(current, size) =>
            setParams({ ...params, current, size })
          }
        />
      </Col>

      <Image
        style={{ display: 'none' }}
        src={imgSrc}
        preview={{
          visible,
          onVisibleChange: value => {
            setVisible(value);
          },
        }}
      />
    </Col>
  );
};
